import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-home-building-icon',
  templateUrl: './home-building.component.html'
})
export class HomeBuildingComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
